export function PageSkeleton({ blocks = 3 }: { blocks?: number }) {
  return (
    <div className="page-skeleton" role="status" aria-label="Loading">
      <div className="page-skeleton__header" />
      <div className="page-skeleton__grid">
        {Array.from({ length: blocks }, (_, i) => (
          <div key={i} className="page-skeleton__block" />
        ))}
      </div>
    </div>
  );
}
